import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import { useNavigate } from 'react-router-dom'
import { pluralize } from 'src/utils/conversion.util'

interface AutoExtractSuccessMessageProps {
  planIds: string[]
  planNames: string[]
}

const AutoExtractSuccessMessage = ({
  planIds,
  planNames,
}: AutoExtractSuccessMessageProps) => {
  const navigate = useNavigate()
  const isMultiElevation = planIds.length > 1
  const plan = pluralize('plan', planNames.length)

  const handlePlanClick = (): void => {
    const planIdParams = planIds.map((id) => `planId=${id}`).join('&')

    const bulkEditUrl = `/bulk-edit?${planIdParams}&basePlanId=${planIds[0]}&submitted=false&familyType=single`
    const planViewUrl = `/edit-plan/${planIds[0]}/draft?familyType=single`

    const urlToNavigate = isMultiElevation ? bulkEditUrl : planViewUrl
    navigate(urlToNavigate)
  }

  return (
    <Box>
      {`Auto extraction is done for ${plan}: ${planNames.join(
        ', '
      )}. Please click `}
      <Link
        component="button"
        onClick={handlePlanClick}
        sx={{ textDecoration: 'underline' }}
      >
        here
      </Link>
      {` to proceed with plan creation.`}
    </Box>
  )
}

export default AutoExtractSuccessMessage
